import React from 'react'
import { BACKEND_URL } from '../../const/Constant'
import styles from '../Expo/expo.module.css'

export default function RentPlaces({el, setShowModal, index, setOpenedIndex}) {
  const open = () => {
    setShowModal(true)
    setOpenedIndex(index)
}

  return (
      <div className={styles['each-image-div']} onClick={open}>
             <div className={styles['image-div']}>
                 <img src={BACKEND_URL + el.image} alt='rent-image'/>
             </div>
      </div>
  )
}
